import Button from "@/components/Button";
import Image from "next/image";
import Link from "next/link";
import posthog from "posthog-js";

const TransformingCare = () => {
    return (
        <div className="px-4 py-8 lg:px-8 bg-card rounded-2xl overflow-hidden">
            {/* Two column layout container */}
            <div className="flex flex-col lg:flex-row md:gap-10 w-full">
                {/* Left Column - Text Content */}
                <div className="flex flex-col lg:w-1/2 order-2 lg:order-1">
                    {/* Title */}
                    <h1 className="text-[#333333] dark:text-white text-2xl sm:text-3xl md:text-[44px] font-semibold font-satoshi uppercase leading-tight md:leading-[57.20px] mb-8 md:mb-10 break-words">
                        Transforming care for complex chronic conditions
                    </h1>

                    {/* Text Content */}
                    <div className="flex flex-col gap-4 mb-8">
                        <p className="text-[#333333] dark:text-gray-300 text-base md:text-lg font-light font-space leading-relaxed break-words">
                            We&apos;re working to make care for
                            infection-associated chronic conditions accessible
                            to everyone in need.
                        </p>
                        <p className="text-[#333333] dark:text-gray-300 text-base md:text-lg font-light font-space leading-relaxed break-words">
                            These conditions lack a straightforward treatment
                            path. Improvement and recovery often require
                            exploring various medications, supplements, diet and
                            lifestyle adjustments, and mind-body interventions.
                        </p>
                        <p className="text-[#333333] dark:text-gray-300 text-base md:text-lg font-light font-space leading-relaxed break-words">
                            We structure our care in a way that advances the
                            science towards better predicting what will help
                            each patient, shortening the path to effective
                            treatment.
                        </p>
                        <p className="text-[#333333] dark:text-gray-300 text-base md:text-lg font-light font-space leading-relaxed break-words">
                            Better care for complex conditions also means
                            creating new tools to quickly understand each
                            patient’s unique case, streamline diagnostic testing
                            and logistics, measure health outcomes to evaluate
                            treatment impact, provide guidance on diet and
                            lifestyle adjustments, and offer robust support for
                            all the questions that arise along the way.
                        </p>
                    </div>

                    <Link
                        href="/team"
                        className="w-full"
                        onClick={() => {
                            posthog?.capture("get_to_know_rthm_button_clicked");
                        }}
                    >
                        <Button
                            text="Get to know RTHM"
                            id="get-to-know-rthm"
                            type="filled"
                            className="uppercase w-80"
                            height="h-[72px]"
                        />
                    </Link>
                </div>

                {/* Right Column - Image Grid */}
                <div className="w-full md:w-[648px] order-1 lg:order-2 mb-8 md:mb-0 min-w-0">
                    {/* Container using aspect ratio */}
                    <div className="relative w-full aspect-648/755">
                        {/* Main grid with consistent proportions */}
                        <div className="absolute inset-0">
                            {/* First Column (212px of 648px ≈ 33%) */}
                            <div className="absolute left-0 w-[32.7%] h-full space-y-2">
                                <div className="relative w-full aspect-212/326">
                                    <Image
                                        src="/images/marketing/TransformingCare1.png"
                                        alt="Transforming care 1"
                                        className="absolute inset-0 w-full h-full object-cover rounded-xl"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                        }}
                                    />
                                </div>
                                <div className="relative w-full aspect-212/421">
                                    <Image
                                        src="/images/marketing/TransformingCare2.png"
                                        alt="Transforming care 2"
                                        className="absolute inset-0 w-full h-full object-cover rounded-xl"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Second Column (428px of 648px ≈ 66%) */}
                            <div className="absolute right-0 w-[66%] h-full">
                                <div className="relative w-full aspect-428/437">
                                    <Image
                                        src="/images/marketing/TransformingCare3.png"
                                        alt="Transforming care 3"
                                        className="absolute inset-0 w-full h-full object-cover rounded-xl"
                                        width={0}
                                        height={0}
                                        sizes="100vw"
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                        }}
                                    />
                                </div>

                                <div className="absolute bottom-0 w-full flex gap-2">
                                    <div className="relative w-[49%] aspect-210/310">
                                        <Image
                                            src="/images/marketing/TransformingCare4.png"
                                            alt="Transforming care 4"
                                            className="absolute inset-0 w-full h-full object-cover rounded-xl"
                                            width={0}
                                            height={0}
                                            sizes="100vw"
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                            }}
                                        />
                                    </div>
                                    <div className="relative w-[49%] aspect-210/310">
                                        <Image
                                            src="/images/marketing/TransformingCare5.png"
                                            alt="Transforming care 5"
                                            className="absolute inset-0 w-full h-full object-cover rounded-xl"
                                            width={0}
                                            height={0}
                                            sizes="100vw"
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransformingCare;
